export const assignName = (inputs: any[]) => {
	inputs.map((input: {name: string; id: string}) => {
		if (input.name === '' && input.id !== '') {
			input.name = input.id;
		}
	});
	return inputs;
};
